import {Component, inject, OnInit, signal} from '@angular/core';
import {CommonModule} from '@angular/common';
import {CommonDropdownComponent} from '@lib-ui/common-dropdawn/common-dropdown.component';
import {MatButton} from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogContent, MatDialogRef, MatDialogTitle } from '@angular/material/dialog';
import {MatError, MatFormField, MatLabel} from '@angular/material/form-field';
import {MatInput} from '@angular/material/input';
import {FormBuilder, ReactiveFormsModule, Validators} from '@angular/forms';
import {MessageService} from '@lib-services/message.service';
import {CategoryService} from '@lib-services/category.service';
import {ICategory, ICategoryCreate, ICategoryUpdate} from '@lib-typing/category.interface';
import {Category} from '@libs-classes/category.class';
import {LoaderComponent} from '@lib-ui/loader/loader.component';
import {AuthService} from '@lib-ui/auth/auth.service';
import {filter, switchMap} from 'rxjs';
import { CloseButtonComponent } from '@lib-ui/close-button/close-button.component';

@Component({
    selector: 'app-category-editor',
    standalone: true,
    imports: [
        CommonModule,
        MatButton,
        MatDialogContent,
        MatFormField,
        MatInput,
        MatLabel,
        ReactiveFormsModule,
        LoaderComponent,
        CloseButtonComponent,
        MatDialogTitle,
    ],
    templateUrl: './category-editor.component.html',
    styleUrl: './category-editor.component.scss'
})
export class CategoryEditorComponent implements OnInit {
    category = new Category({} as ICategory);
    loading = signal(false);

    readonly dialogRef = inject(MatDialogRef<CategoryEditorComponent>);
    readonly fb = inject(FormBuilder);
    readonly categoryService = inject(CategoryService);
    // protected companySelectorService = inject(CompanySelectorService);
    protected messagesService = inject(MessageService);
    protected authService = inject(AuthService);
    public data: { categoryId?: number } = inject(MAT_DIALOG_DATA);

    categoryForm= this.fb.group({
        name: ['', Validators.required],
        customId: ['', Validators.maxLength(100)],
        equipmentExTableName: [''],
        // companyId: [0, Validators.required],
    });

    ngOnInit(): void {
        if (this.data.categoryId) {
            this.loading.set(true);
            this.categoryService.getCategory(this.data.categoryId).subscribe( {
                next: data => {
                    this.category.data = data;
                    this.categoryForm.patchValue(this.category.formData());
                },
                error: error => {this.messagesService.errorMessage(error.message);}
            }).add(() => this.loading.set(false));
        }
    }

    onSubmit(): void {
        if (!this.categoryForm.valid) {
            return;
        }

        this.loading.set(true);
        const request = this.category.data.id
            ? this.categoryService.updateCategory(this.category.dataForUpdate(this.categoryForm.value as ICategoryUpdate))
            :  this.categoryService.createCategory(this.category.dataForCreate(this.categoryForm.value as ICategoryCreate));

        request.subscribe({
            next: result => {
                this.messagesService.successMessage('Категория успешно сохранена');
                this.dialogRef.close(result);},
            error: error => {
                const errorMessage = error?.error?.message?.includes('duplicate key value')
                    ? 'Категория с таким CustomID уже существует.': (error.message);
                this.messagesService.errorMessage(errorMessage);
            }
        }).add(() => this.loading.set(false));
    }

    deleteCategory(id: number): void {
        this.messagesService.confirmMessage({
            title: 'Удаление категории',
            text: 'Вы действительно хотите удалить категорию?',
            primaryText: 'Удалить',
            secondaryText: 'Отмена',
            showSecondaryButton: true,
        }).pipe(
            filter(result => result),
            switchMap(() => {
                return this.categoryService.deleteCategories([id]);
            }),
        ).subscribe({
            next: () => {
                this.messagesService.successMessage('Категория успешно удалены');
                this.dialogRef.close(true);
            },
            error: () => this.messagesService.errorMessage('При удалении произошла ошибка')
        });
    }
}
